import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput,NumberField
 }
from 'admin-on-rest/lib/mui';

export const negativeTurnoverList = (props) => (
    <List title="יחס ביטולים/מחזור" {...props}>
        <Datagrid>
        <TextField label="בית עסק" source="buisiness_id" />
        <NumberField label="סך ביטולים" source="sum_zikui_total_bruto" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
            <NumberField label="ממוצע עסקאות" source="sumIskot" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
             <NumberField label="יחס ביטולים" source="turnoberRatio" locales="he-IL" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
             
             
            
  
        </Datagrid>
    </List>
);




              



// WEBPACK FOOTER //
// ./src/components/RiskManagement/negativeTurnover/negativeTurnover.js